import qs from 'qs'

import { PeriodMode } from '../../../enums/periodMode'
import type { BalanceStatementQueryParams } from '../types/balanceStatementQueryParams'

// Shared by both sides: creditorBalanceStatement and debtorBalanceStatement take the same query params.
export const buildBalanceStatementQueryParams = ({
  period,
  page,
  pageSize,
  search,
  sortBy,
  sortDirection,
}: BalanceStatementQueryParams): string =>
  qs.stringify(
    {
      ...(period && period !== PeriodMode.All ? { period } : {}),
      ...(search ? { search } : {}),
      ...(page ? { page } : {}),
      ...(pageSize ? { pageSize } : {}),
      ...(sortBy ? { sortBy } : {}),
      ...(sortDirection ? { sortDirection } : {}),
    },
    { arrayFormat: 'brackets' },
  )
